module.exports = __webpack_public_path__ + "static/Behavioural-Graphic@3x-750c9abfcddf0be37f7dbea8fc36ed35.png";